import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { brewBatchId } from "@brewbase/db/types";

export const Route = createFileRoute("/batches/$batch_id")({
  params: z.object({
    batch_id: z.coerce.number().transform((val) => brewBatchId.parse(val)),
  }),
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/harvests/batches/$batch_id", params });
  },
});
